export const getDataSourceRelationForEventTracking = name => {
  if (!name) {
    return '';
  }
  if (name.length > 4 && name.substring(0, 3).toLowerCase() === 'all') {
    return 'All label';
  }
  if (name.toLowerCase() === 'primary') {
    return 'Primary label';
  }
  return 'Custom label';
};